/**
 * チャートのツールチップ index (Recharts の `activeTooltipIndex`) から、ホバー中の
 * コマの 0 始まり index を解決する。
 *
 * index はデータ行の位置なので、行が持つ backend のコマ番号 (1 始まり) を引いて
 * 変換する。ホバーが外れた (null / 空文字) ・範囲外・非整数は undefined。
 */
export function hoveredKomaIndexOf(
  data: ReadonlyArray<{ koma: number }>,
  activeTooltipIndex: number | string | null | undefined,
): number | undefined {
  // 空文字は `Number('')` が 0 になり先頭行と解釈されてしまうので弾く。
  const rowIndex =
    typeof activeTooltipIndex === 'number'
      ? activeTooltipIndex
      : typeof activeTooltipIndex === 'string' &&
          activeTooltipIndex.trim() !== ''
        ? Number(activeTooltipIndex)
        : NaN
  if (!Number.isInteger(rowIndex)) {
    return undefined
  }
  const koma = data[rowIndex]?.koma
  return koma === undefined ? undefined : koma - 1
}

/**
 * 天気帯でハイライトするセル (0 始まりコマ index) の集合 (AC-BDB-010c)。
 * ホバー中のコマに加え、現在コマは常時ハイライトする。
 *
 * コマがどのセルのアイコンに対応するかは行ごとに異なるので、`cellOfKoma` で受け取る
 * (アイコンの置き方と同じ場所で定義する)。対応するセルが無いコマ (undefined) は
 * ハイライト対象にしない。
 */
export function weatherStripHighlightCells(
  hoveredKomaIndex: number | undefined,
  currentKomaIndex: number | undefined,
  cellOfKoma: (komaIndex: number) => number | undefined,
): ReadonlySet<number> {
  const cells = new Set<number>()
  for (const index of [hoveredKomaIndex, currentKomaIndex]) {
    if (index !== undefined && index >= 0) {
      const cell = cellOfKoma(index)
      if (cell !== undefined) {
        cells.add(cell)
      }
    }
  }
  return cells
}
